import { FbAdapter } from '../../social/fb/adapter';
import { container } from '../../utils/container/container';
import { ServiceIds } from '../../utils/container/service-ids';

export function getFbAdapter(): FbAdapter {
    if (container.isBound(ServiceIds.FB_ADAPTER)) {
        return container.get<FbAdapter>(ServiceIds.FB_ADAPTER);
    }

    const adapter = new FbAdapter(window.app.config.fb.oauth_app_id);
    container.bind<FbAdapter>(ServiceIds.FB_ADAPTER).toConstantValue(adapter);
    return adapter;
}
